import React from "react";
import { Section } from "../Section";
import { Flex } from "../flex";
import { ButtonPrimary } from "../Button";

import { StaticImage } from "gatsby-plugin-image";
import instagramLogo from "../../images/insta.svg";

export const Contact = () => {
  return (
    <Section bg="white">
      <div className="w-full lg:p-0">
        <div id="contact-form" className="relative bottom-[64px]"></div>
        <h2 className="header text-roseExtraLight">Contact</h2>
        <div className="flex flex-col justify-between gap-8 mt-8 lg:flex-row ">
          <div className="bg-white items-center shadow-xl flex justify-center lg:w-1/2 p-8 border-2 rounded-tr-[60px] rounded-bl-[60px] border-roseExtraLight">
            <ul className="mb-0 md:mb-0">
              <li className="flex">
                <div className="relative flex items-center justify-center w-10 h-10 rounded top-1 bg-roseExtraLight">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="w-6 h-6"
                  >
                    <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                    <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                  </svg>
                </div>
                <div className="mb-4 ml-4">
                  <h3 className="text-[22px] mb-1 font-bold">Our Location</h3>
                  <p className="mb-2">Edgewater, New Jersey</p>
                  <p className="mb-2 text-sm italic">
                    *address provided upon placement of appointment
                  </p>
                </div>
              </li>
              <li className="flex">
                <div className="relative flex items-center justify-center w-10 h-10 rounded top-1 bg-roseExtraLight text-gray-50">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="w-6 h-6"
                  >
                    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
                    <path d="M15 7a2 2 0 0 1 2 2"></path>
                    <path d="M15 3a6 6 0 0 1 6 6"></path>
                  </svg>
                </div>
                <div className="mb-4 ml-4">
                  <h3 className="text-slate-700 text-[22px] mb-1 font-bold">
                    Contact
                  </h3>

                  <div className="flex flex-col gap-2">
                    <a
                      href="mailto:Healthnbloom@gmail.com"
                      className="flex items-center gap-2 mb-0 group"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="#D3C3B2"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-6 h-6"
                      >
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z" />
                        <path d="m22 6-10 7L2 6" />
                      </svg>
                      <span className="transition translate-x-0 !text-[16px] group-hover:translate-x-1 group-hover:underline">
                        Healthnbloom@gmail.com
                      </span>
                    </a>

                    <a
                      href="https://www.instagram.com/healthnbloom?igsh=cnh2MTB3bTJudDg3"
                      className="flex items-center gap-2 mb-0 group"
                    >
                      <StaticImage
                        src="../../images/insta.svg"
                        alt="Instagram logo"
                        placeholder="blurred"
                        layout="fixed"
                        formats={["auto", "webp"]}
                        width={22}
                      />
                      <span className="transition group-hover:translate-x-1 !text-[16px] group-hover:underline">
                        @HealthnBloom
                      </span>{" "}
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex">
                <div className="relative flex items-center justify-center w-10 h-10 rounded top-1 bg-roseExtraLight text-gray-50">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="w-6 h-6"
                  >
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                    <path d="M12 7v5l3 3"></path>
                  </svg>
                </div>
                <div className="mb-0 ml-4">
                  <h3 className="text-[22px] mb-1 font-bold">Working hours</h3>
                  <p className="mb-0 text-gray-600 ">
                    <span>Monday - Friday</span>
                    <span className="text-[20px] text-slate-400">
                      {" "}
                      10:00AM - 6:00PM
                    </span>
                  </p>
                  <p className="mb-0 text-gray-600 ">
                    <span>Saturday &amp; Sunday:</span>
                    <span className="text-[20px] text-slate-400"> Closed</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-white shadow-xl flex justify-center lg:w-1/2 p-8 border-2 rounded-tl-[60px] rounded-br-[60px] border-roseExtraLight">
            <form
              name="contact"
              method="POST"
              data-netlify="true"
              action="/thank-you"
              netlify-honeypot="bot-field"
              id="appointments"
            >
              {/* Netlify bot field (spam prevention) */}
              <input type="hidden" name="form-name" value="contact" />
              <p hidden>
                <label>
                  Don’t fill this out: <input name="bot-field" />
                </label>
              </p>

              <div className="px-8 py-4">
                <div className="mb-4">
                  <label className="block mb-2 text-[20px]">Full Name:</label>
                  <input
                    className="outline-roseExtraLight w-[296px] px-3 py-2 border-2 rounded"
                    type="text"
                    name="full_name"
                    id="full_name"
                    placeholder="Enter Your Full Name"
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="block mb-2 text-[20px]">
                    Service Interest:
                  </label>
                  <input
                    className="w-full px-3 py-2 border-2 border-solid rounded outline-roseExtraLight"
                    type="text"
                    name="student_name"
                    id="student_name"
                    placeholder="Let Us Know What Services Interest You"
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="block mb-2 text-[20px]">
                    Phone Number:
                  </label>
                  <input
                    className="w-full px-3 py-2 border-2 rounded outline-roseExtraLight"
                    type="tel"
                    name="Phone"
                    id="Phone"
                    placeholder="Enter Your Phone Number"
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="block mb-2 text-[20px]">
                    Preferred Appt. Date:
                  </label>
                  <input
                    className="w-full px-3 py-2 border-2 border-gray-200 rounded text-copy outline-roseExtraLight"
                    type="datetime-local"
                    name="datetime_date"
                    id="datetime_date"
                    required
                  />
                </div>

                <div className="relative mb-4 top-3">
                  <ButtonPrimary className="w-full" color="brown">
                    Submit
                  </ButtonPrimary>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Section>
  );
};
